// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"2e494d10","513":"c5c507bd","703":"04f474e0","787":"301a0b18"}[chunkId] + ".chunk.js";
};